module.exports = __webpack_public_path__ + "img/people.8cfc3756.svg";